import { render, staticRenderFns } from "./tabMailAddress.vue?vue&type=template&id=9c48cada&scoped=true"
import script from "./tabMailAddress.vue?vue&type=script&lang=js"
export * from "./tabMailAddress.vue?vue&type=script&lang=js"
import style0 from "./tabMailAddress.vue?vue&type=style&index=0&id=9c48cada&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c48cada",
  null
  
)

export default component.exports